import irFlag from "../assets/flags/ir.png";

import zod_fa from "../i18n/zod/fa.json";

export type TextDirection = "ltr" | "rtl";

interface ZodMessages {
	errors: Record<string, any>;
	validations: Record<string, any>;
	types: Record<string, any>;
}

export interface LanguageData {
	code: Language;
	name: string;
	flag: string;
	mode: TextDirection;
	zodPath: ZodMessages;
}

export const LANGUAGES = {
	fa: {
		code: "fa",
		name: "Persian",
		flag: irFlag,
		mode: "rtl",
		zodPath: zod_fa,
	},
} as const;

export type Language = keyof typeof LANGUAGES;

export const LANGUAGE_KEYS = Object.keys(LANGUAGES) as Language[];
LANGUAGES satisfies Record<Language, LanguageData>;
